import React, { useEffect, useState } from "react";
import { Button } from "@repo/ui";
import { useNavigate } from "react-router-dom";
import editIcon from "../../../../assets/icons/edit.svg";
import linkIcon from "../../../../assets/icons/link.svg";
import { useAppSelector } from "../../../../hooks/useAppDispatch";
import { RootState } from "../../../../redux/store";
import { FaGift } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import { sumGiftsByGiftTableID } from "../../../../services/giftApiService";

const LOCALE = "modules_MyGiftTable_components_AsideSection_ActionButtons";

const ActionButtons: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const navigate = useNavigate();
  const [shouldBlink, setShouldBlink] = useState(false);
  const [giftCount, setGiftCount] = useState<number>(0);

  const giftTable = useAppSelector((state: RootState) => state.giftTable);
  const highlightShareButton = useAppSelector(
    (state: RootState) =>
      state.eventBus["myGiftTable-withDrawSection-highlightShareButton"]
  );
  const { ID, status } = giftTable;

  // Fetch the gift count from the endpoint
  useEffect(() => {
    if (ID) {
      sumGiftsByGiftTableID(ID)
        .then((result) => {
          setGiftCount(result.count);
        })
        .catch((error) => {
          console.error("Error fetching gift count by gift table ID", error);
        });
    }
  }, [ID]);

  // Simplified share table handler, since the button won't render if status is "draft"
  const handleShareTable = () => {
    navigate("/my-table/share");
  };

  useEffect(() => {
    if (highlightShareButton) {
      setShouldBlink(true);
      const timer = setTimeout(() => setShouldBlink(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [highlightShareButton]);

  const handleViewGifts = () => {
    navigate("/my-table/gifts");
  };

  return (
    <>
      {/* View Received Gifts Button */}
      <Button
        onClick={handleViewGifts}
        className="w-full"
        label={
          <div className="flex items-center justify-between">
            <span>{t("received-gifts")}</span>
            <h4 className="font-bold text-left ml-2">
              {giftCount.toLocaleString()}
            </h4>
            <FaGift className="ml-2" />
          </div>
        }
        type="secondary"
      />
      {/* Edit Table Button */}
      <Button
        className="w-full"
        label={
          <div className="flex items-center justify-between">
            <span>{t("edit-table")}</span>
            <img src={editIcon} alt="Edit" className="ml-2 h-4 w-4" />
          </div>
        }
        type="secondary"
        onClick={() => navigate("/my-table/edit")}
      />
      {/* Conditionally render Share Table Button only when status is not "draft" */}
      {status !== "draft" && (
        <Button
          className={`w-full ${shouldBlink ? "highlight-blink" : ""}`}
          children={
            <div className="flex items-center justify-between">
              <span>{t("share-table")}</span>
              <img src={linkIcon} alt="Link" className="ml-2 h-4 w-4" />
            </div>
          }
          type="secondary"
          onClick={handleShareTable}
        />
      )}
    </>
  );
};

export default withTranslations(LOCALE)(ActionButtons);
